import { useField } from 'formik';

import { controlError } from 'utils';

import { Input, InputProps } from '../input';

export interface InputFieldProps extends Omit<InputProps, 'name'> {
  name: string;
  label?: string;
  controlErrorLabel?: boolean;
  onChange?: InputProps['onChange'];
}

export function InputField({
  name,
  label,
  onChange,
  controlErrorLabel = true,
  ...props
}: InputFieldProps) {
  const [field, meta] = useField<string>(name);

  const errorText = controlError(meta, name, label, controlErrorLabel);

  return (
    <Input
      {...props}
      {...field}
      label={label}
      error={!!errorText}
      helperText={errorText}
      onChange={(event) => {
        field.onChange(event);
        onChange?.(event);
      }}
    />
  );
}
